export const iconFontAwesomeDevicesHardwareFax = (
	<i className="fa-solid fa-fax"></i>
);
